<template>
    <div class="ui-dotlotie-loader">
        <div class="anim-container" :style="{ paddingTop: aspectRatio }">
            <canvas :id="domID" class="anim"></canvas>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { DotLottie } from '@lottiefiles/dotlottie-web';
export default {
    name: 'ui-dotlottie-loader',
    props: {
        aspect: {
            type: String,
            default: '2:1'
        },
        loop: {
            type: Boolean,
            default: false
        },
        lottieLocation: {
            type: String,
            default: '/lottiefiles'
        },
        lottie: {
            type: String,
            default: "check"
        }
    },
    computed: {
        cLottie(){
            return this.lottieLocation + '/' + this.lottie + '.json';
        },
        aspectRatio() {
            const [width, height] = this.aspect.split(':');
            return `${(height / width) * 100}%`;
        }
    },
    data: () => {
        return {
            domID: null,
            dotLottie: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.dotLottie = new DotLottie({
                autoplay: true,
                loop: this.loop,
                canvas: document.querySelector('#' + this.domID),
                src: this.cLottie, 
            });
        });
    },
    beforeMount(){
        this.domID = _.uniqueId('dotlottie-canvas-');
    }
}
</script>

<style lang="scss">
.ui-dotlotie-loader {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // height: 100vh;

    .anim {
        &-container {
            width: 100%;
            height: auto;
            position: relative;
            padding-top: 50%;
            /* 1:2 aspect ratio */
            padding-top: 33.33%;
            /* 1:3 aspect ratio */
            // padding-top: 66.66%;
            /* 2:3 aspect ratio */
            height: 0;
        }

        & {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
}
</style>